import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { faMoon, faQuestionCircle } from "@fortawesome/pro-light-svg-icons";
import { FaIconLibrary } from "@fortawesome/angular-fontawesome";
import { LogoComponent } from "@shared/components/logo/logo.component";
import { DiashowComponent } from "../../ui/diashow/diashow.component";
import { IconModule } from "@ogs/ngx-m3-components";
import { RouterModule } from "@angular/router";
import { MatButtonModule } from "@angular/material/button";
import { LanguageSelectComponent } from "@shared/components/language-selection/components/language-select/language-select.component";
import { TranslationPipeModule } from "@ogs-gmbh/ngx-translate";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-authenticate-layout-auth",
  templateUrl: "auth.component.html",
  styleUrl: "auth.component.scss",
  imports: [ LogoComponent,
    DiashowComponent,
    IconModule,
    RouterModule,
    MatButtonModule,
    LanguageSelectComponent,
    TranslationPipeModule ],
  standalone: true
})
export class AuthComponent {
  private readonly faIconLibrary: FaIconLibrary = inject(FaIconLibrary);

  constructor () {
    this.faIconLibrary.addIcons(faQuestionCircle, faMoon);
  }
}
